<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>

      <b-form-group :label="$t('gateways.mode')" :state="validateState('mode')">
        <multiselect
          v-model="form.mode"
          :options="modeList"
          :allowEmpty="false"
          :show-labels="false"
          :searchable="true"
          :placeholder="$t('gateways.mode')"
          :show-no-results="false"
        />
      </b-form-group>

      <Checkbox
        label="gateways.isTlsServer"
        id="isTlsServer"
        v-model="form.isTlsServer"
        class="mb-3"
      />

      <NumberInput
        label="global.port"
        id="port"
        placeholder="examples.port"
        v-model="form.port"
        :state="validateState('port')"
      />

      <b-form-group
        :label="$t('global.protocol')"
        :state="validateState('protocol')"
      >
        <multiselect
          v-model="form.protocol"
          :options="protocolList"
          :allowEmpty="false"
          :show-labels="false"
          :searchable="true"
          :placeholder="$t('global.protocol')"
          :show-no-results="false"
        />
      </b-form-group>

      <Input
        label="gateways.dev"
        id="dev"
        placeholder="gateways.dev"
        v-model="form.dev"
        :state="validateState('dev')"
      />

      <div class="row">
        <div class="col-6">
          <NumberInput
            label="gateways.keepAlive"
            id="keepAlive"
            placeholder="examples.number"
            v-model="form.keepAliveMin"
            :state="validateState('keepAliveMin')"
          />
        </div>
        <div class="col-6">
          <NumberInput
            label=""
            id="keepAlive"
            placeholder="examples.number"
            v-model="form.keepAliveMax"
            :state="validateState('keepAliveMax')"
            class="mt-9"
          />
        </div>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  name: 'GatewayVPNCreate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    gatewayId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        mode: '',
        isTlsServer: '',
        port: '',
        protocol: '',
        dev: '',
        keepAliveMin: '',
        keepAliveMax: '',
      },
      loading: false,
      modeList: '',
      protocolList: '',
    }
  },
  validations: {
    form: {
      mode: {
        required,
      },
      port: {
        required,
        minValueValue: minValue(0),
        maxValueValue: maxValue(9999),
      },
      protocol: {
        required,
      },
      dev: {
        required,
      },
      keepAliveMin: {
        required,
        minValueValue: minValue(0),
        maxValueValue: maxValue(9999),
      },
      keepAliveMax: {
        required,
        minValueValue: minValue(0),
        maxValueValue: maxValue(9999),
      },
    },
  },
  created() {
    this.modeList = ['server', 'client']
    this.protocolList = ['TCP', 'UDP']
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }
      this.loading = true

      let params = {
        mode: this.form.mode,
        is_tls_server: this.form.isTlsServer,
        port: this.form.port,
        proto: this.form.protocol,
        dev: this.form.dev,
        keepalive: this.form.keepAliveMin + ' ' + this.form.keepAliveMax,
      }

      ApiService.post(`packetbender/netgateways/${this.gatewayId}/vpn`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.loading = false
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
          this.loading = false
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
